import React from "react";
import { store } from "../../../redux/storeConfig/store";
import { history } from "../../../app/AppRouter";
import { setEndStaffSessionModalOpen } from "../../../redux/actions/staffSession/staffSessionAction";

export const StepButton = (props) => {
  return (
    <>
      <div className="action-wrapper blk-padding-y">
        <div className="action-inner-block">
          <div className="action-btn-block d-flex">
            <button
              className="btn btn-medium btn-transparent"
              onClick={() => {
                store.dispatch(setEndStaffSessionModalOpen(false));
              }}
            >
              Cancel
            </button>
            <button className="btn btn-medium">
              End Session
            </button>
          </div>
        </div>
      </div>
    </>
  );
};
